import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Card = ({ children, className, ...props }) => {
  return (
    <div className={classNames('card', className)} {...props}>
      {children}
    </div>
  );
};

Card.Header = ({ children, className, ...props }) => {
  return (
    <div className={classNames('card-header', className)} {...props}>
      {children}
    </div>
  );
};
Card.Header.displayName = 'Card.Header';

Card.Body = ({ children, className, ...props }) => {
  return (
    <div className={classNames('card-body', className)} {...props}>
      {children}
    </div>
  );
};
Card.Body.displayName = 'Card.Body';

const commonProps = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
      ]),
    ),
  ]),
};

Card.propTypes = commonProps;
Card.Header.propTypes = commonProps;
Card.Body.propTypes = commonProps;

export { Card };
